import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { JniToastrService } from "../../../core/services/jni-toastr.service";
import { LoaderService } from "../../../core/services/loader.service";
import { ProjectWorkflowService } from "../../../core/services/project-workflow.service";
import { ProjectWorkFlowLinesTemplates } from "../../../core/models/project-workflow/projectWorkFlowLinesTemplates";
import { WorkflowLineTemplatesFormComponent } from "../workflow-line-templates-form/workflow-line-templates-form.component";
import { TableModule } from "primeng/table";
import { CommonModule } from "@angular/common";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";
import { DialogModule } from "primeng/dialog";

@Component({
  selector: "jni-workflow-line-templates",
  templateUrl: "./workflow-line-templates.component.html",
  styleUrls: ["./workflow-line-templates.component.scss"],
  imports: [
    WorkflowLineTemplatesFormComponent,
    TableModule,
    CommonModule,
    ButtonModule,
    CardModule,
    InputTextModule,
    DialogModule,
  ],
})
@UntilDestroy()
export class WorkflowLineTemplatesComponent implements OnInit {
  @Input() displaySelectTemplatesDialog!: boolean;
  @Output() closeSelectTemplatesDialogEvent = new EventEmitter();
  @Output() emitSelectedTemplatesDialogEvent = new EventEmitter<string>();

  filerLinesTemplatesListing: ProjectWorkFlowLinesTemplates[] = [];
  selectedTemplate: ProjectWorkFlowLinesTemplates =
    {} as ProjectWorkFlowLinesTemplates;
  displayAddNewTemplateModal = false;

  constructor(
    private _toastr: JniToastrService,
    private _loaderService: LoaderService,
    private _productionWorkflowService: ProjectWorkflowService
  ) {}

  ngOnInit(): void {
    this.getAllTemplates();
  }

  getAllTemplates() {
    this._productionWorkflowService
      .getProjectWorkFlowLinesTemplates()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res?.data) {
            this.filerLinesTemplatesListing = res.data;
          } else {
            this.filerLinesTemplatesListing = [];
          }
        },
        error: () => {
          this._toastr.error("Error", "Unable to Project List");
        },
      });
  }

  deleteTemplate() {
    this._loaderService.setLoaderState(true);
    this._productionWorkflowService
      .deleteProjectWorkFlowLinesTemplates(this.selectedTemplate?.id ?? 0)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.data) {
            this._toastr.success(
              "Success",
              res.message || "Template deleted successfully"
            );
            this.getAllTemplates();
          } else {
            this._toastr.error(
              "Error",
              res.message || "Error Occured While Deleting the template"
            );
          }
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastr.error(
            "Error",
            res.message || "Error Occured While Deleting the template"
          );
        },
      });
  }

  showAddNewTemplateDialog() {
    this.displayAddNewTemplateModal = true;
  }

  selectAddTemplate() {
    this.emitSelectedTemplatesDialogEvent.emit(
      this.selectedTemplate.description ?? ""
    );
    this.closeTemplateDialog();
  }

  closeTemplateDialog() {
    this.displaySelectTemplatesDialog = false;
    this.closeSelectTemplatesDialogEvent.emit();
  }

  closeAndRefreshTemplatesGridEvent() {
    this.closeAddUpdateTemplateDialogEvent();
    this.getAllTemplates();
  }

  closeAddUpdateTemplateDialogEvent() {
    this.displayAddNewTemplateModal = false;
  }
}
